// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
}
.btn-primary {
  color: #fff;
  background-color: #8784ee;
  border-color: #4a5582;
}
.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}
.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
.btn.disabled,
.btn[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  -webkit-box-shadow: none;
  box-shadow: none;
  opacity: 0.65;
}
button.close {
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
}
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.table-responsive {
  min-height: 0.01%;
  overflow-x: auto;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
}
table {
  border-spacing: 0;
  border-collapse: collapse;
}
th {
  text-align: left;
}
.AboutContent .btn {
  border-color: #ccc;
}
.AboutContent .table thead:first-child tr:first-child th,
.AboutContent .table thead:first-child tr:first-child td {
  border-top: 0;
}
.AboutContent .table thead tr th,
.AboutContent .table tbody tr th,
.AboutContent .table tfoot tr th,
.AboutContent .table thead tr td,
.AboutContent .table tbody tr td,
.AboutContent .table tfoot tr td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/common/button.styl","webpack://./../../ui/src/components/content/aboutContent/AboutContent.styl","webpack://./../../ui/src/components/content/aboutContent/table.styl"],"names":[],"mappings":"AAAA;EACE,WAAO;EACP,yBAAkB;EAClB,qBAAc;ACChB;ADCA;EACE,WAAO;EACP,yBAAkB;EAClB,qBAAc;ACChB;ADCA;EACE,WAAO;EACP,sBAAkB;EAClB,kBAAc;ACChB;ADCA;EACE,qBAAS;EACT,iBAAS;EACT,gBAAe;EACf,eAAW;EACX,gBAAa;EACb,uBAAa;EACb,kBAAY;EACZ,mBAAa;EACb,sBAAgB;EAChB,8BAAkB;EAClB,0BAAc;EACd,eAAQ;EACR,yBAAqB;EACrB,sBAAkB;EAClB,qBAAiB;EACjB,iBAAa;EACb,sBAAkB;EAClB,6BAAQ;EACR,kBAAe;ACCjB;ADCA;;;EACE,mBAAQ;EACR,wBAAoB;EACpB,gBAAY;EACZ,aAAS;ACGX;ADDA;EACE,wBAAoB;EACpB,UAAS;EACT,eAAQ;EACR,eAAY;EACZ,SAAQ;ACGV;ADDA;;EACE,kBAAU;EACV,qBAAS;EACT,sBAAgB;ACIlB;ADFA;EACE,uBAAS;EACT,mBAAW;EACX,gBAAa;EACb,qBAAe;ACIjB;AC9DA;EACE,iBAAY;EACZ,gBAAY;ADgEd;AC9DA;EACE,WAAO;EACP,eAAW;EACX,mBAAe;ADgEjB;AC9DA;EACE,iBAAgB;EAChB,yBAAiB;ADgEnB;AC9DA;EACE,gBAAY;ADgEd;AA1EE;EACE,kBAAc;AA4ElB;AAvEQ;;EACE,aAAY;AA0EtB;AAtEQ;;;;;;EACE,YAAS;EACT,uBAAa;EACb,mBAAgB;EAChB,0BAAY;AA6EtB","sourcesContent":[".btn-danger\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n\n.btn-primary\n  color: #fff;\n  background-color: #8784EE;\n  border-color: #4A5582;\n\n.btn-default\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n\n.btn\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n\n.btn.disabled, .btn[disabled], fieldset[disabled] .btn\n  cursor: not-allowed;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  opacity: .65;\n\nbutton.close\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n\n.btn-group, .btn-group-vertical\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n\n.btn-sm\n  padding: .25rem .5rem;\n  font-size: .875rem;\n  line-height: 1.5;\n  border-radius: .2rem;\n","@import '../../common/button.styl'\n@import './table.styl'\n\n.AboutContent\n  .btn\n    border-color: #ccc;\n\n  .table\n    thead:first-child\n      tr:first-child\n        th, td\n          border-top: 0;\n\n    thead, tbody, tfoot\n      tr\n        th, td\n          padding: 8px;\n          line-height: 1.42857143;\n          vertical-align: top;\n          border-top: 1px solid #ddd;\n",".table-responsive\n  min-height: .01%;\n  overflow-x: auto;\n\n.table\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n\ntable\n  border-spacing: 0;\n  border-collapse: collapse;\n\nth\n  text-align: left;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
